import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { SkeletonProps, SkeletonVariant } from './types';

const variantClasses: Record<SkeletonVariant, string> = {
  default: '',
  text: 'skeleton-text',
};

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, variant = 'default', ...props }, ref) => {
    const classes = twMerge('skeleton', variantClasses[variant], className);

    return <div ref={ref} className={classes} {...props} />;
  },
);

Skeleton.displayName = 'Skeleton';
